import ProductImage from "./product-image";
import ShopInfo from "./shop-info";

const ShopList = ({ products }) => {
  return (
    <div className="max-w-5xl mx-auto px-5 py-10 md:py-20 space-y-16 md:space-y-28">
      {products.map((product, idx) => {
        const { title, description, link, img } = product;
        const even = (idx + 1) % 2 === 0;
        return (
          <div
            key={idx}
            className={`flex flex-col md:flex-row items-center gap-10 md:gap-16 ${
              even && "md:flex-row-reverse"
            }`}
          >
            <ShopInfo
              title={title}
              description={description}
              link={link}
              className={"flex-1"}
            />
            <ProductImage className={`w-[min(250px,100%)] `} img={img} />
          </div>
        );
      })}
    </div>
  );
};
export default ShopList;
